import { BillkeyRegistrationInfo } from 'api/Api';
import BillkeyRegisterForm from 'app/components/BillkeyRegisterForm';
import LoadingIndicator from 'app/components/LoadingIndicator';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

const browserTypeJson = (lang: string) => {
  switch (lang) {
    case 'zh-TW':
      return 'cntr';
    case 'zh-CN':
      return 'cnsi';
    case 'en-US':
      return 'en';
    case 'ko':
      return 'ko';
    case 'ko-KR':
      return 'ko';
    case 'ja':
      return 'jp';
    default:
      return '';
  }
};

const Billkey = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const searchParams = useLocation().search;
  const { setPaymentState } = usePaymentState();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [language, setLanguage] = useState<string>('');
  const [langUse, setLangUse] = useState<string>();
  const [keypadToken, setKeypadToken] = useState<string>('');
  const [keyinType, setKeyinType] = useState<string>('');

  const clearStorage = () => {
    window.sessionStorage.removeItem('auth');
    window.sessionStorage.removeItem('clientKey');
    window.sessionStorage.removeItem('mid');
    window.sessionStorage.removeItem('formSubmitted');
  };

  const updatePaymentState = infoData => {
    setPaymentState(prevState => ({
      ...prevState,
      mid: infoData.mid,
      clientKey: infoData.clientKey,
      returnUrl: infoData.returnUrl,
      orderId: infoData.orderId,
      webhookUrl: infoData.webhookUrl,
    }));
  };

  const getBillkeyInfo = useMutation(() => BillkeyRegistrationInfo(), {
    onSuccess: data => {
      if (String(data.data.resultStatus).toUpperCase() === 'SUCCESS') {
        setKeypadToken(data.data.keypadToken);
        setKeyinType(data.data.keyinType);
        setPaymentState(prevData => ({
          ...prevData,
          tid: data.data.tid,
        }));
        setIsLoading(false);
      } else {
        setPaymentState(prevData => ({
          ...prevData,
          resultCode: data.data.resultCode,
          resultMessage: data.data.resultMessage,
          resultStatus: data.data.resultStatus,
          // tid: data.data.tid,
        }));
        navigate('/error');
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  useEffect(() => {
    clearStorage();

    const params = new URLSearchParams(searchParams);
    const mid = params.get('mid');
    const clientKey = params.get('clientKey');
    const orderId = params.get('orderId');
    const returnUrl = params.get('returnUrl');
    const webhookUrl = params.get('webhookUrl');

    updatePaymentState({
      mid,
      clientKey,
      returnUrl,
      orderId,
      webhookUrl,
    });

    if (mid) {
      window.sessionStorage.setItem('mid', mid);
    }
    if (clientKey) {
      window.sessionStorage.setItem('clientKey', clientKey);
    }

    getBillkeyInfo.mutate();
  }, []);

  useEffect(() => {
    // langUse 사용유무에 따라 Y/N
    // Y > BO에 설정된 언어로 초기언어 설정
    // N > 브라우저 언어설정을 language로 설정 이외 언어시 BO 설정된 언어로 로딩
    if (language) {
      if (langUse === 'Y') {
        i18n.changeLanguage(language);
      } else {
        const userLanguage = navigator.language;
        const browserLanguage = browserTypeJson(userLanguage);
        if (browserLanguage !== '') {
          i18n.changeLanguage(browserLanguage);
          return;
        }
        i18n.changeLanguage(language);
      }
    } else {
      const userLanguage = navigator.language;
      const browserLanguage = browserTypeJson(userLanguage);
      if (browserLanguage !== '') {
        i18n.changeLanguage(browserLanguage);
        return;
      } else {
        i18n.changeLanguage('en');
      }
    }
  }, [language, langUse]);

  return (
    <>
      <div className="a-sectio"></div>
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <BillkeyRegisterForm keyinType={keyinType} keypadToken={keypadToken} />
      )}
    </>
  );
};

export default Billkey;
